import { getCountryCodeCookie } from '@helpers/getCountryCodeCookie';
import { isApprovedStudyArea, isRestOfWorld, isUk } from '@helpers/countryGroups';

//TODO: THIS SHOULD BE MOVED TO KONTENT.AI
const regionParamRequiredForms = ['/request/ug-qual-reg-form/', '/request/thank-you/ug-qual-reg-thank-you/'];

const getRegion = (countryCodeCookie) => {
  if (isUk(countryCodeCookie)) {
    return 'uk';
  } else if (isApprovedStudyArea(countryCodeCookie)) {
    return 'asa';
  } else if (isRestOfWorld(countryCodeCookie)) {
    return 'row';
  }
  console.warn(
    `Country with code ${countryCodeCookie.code} and pricing area code ${countryCodeCookie.pricingAreaCode} does not belong to any region group.`
  );
  return null;
};

export function ensureRegionParam(location) {
  if (!regionParamRequiredForms.includes(location.pathname)) return;

  const countryCodeCookie = getCountryCodeCookie();
  if (!countryCodeCookie) return;

  const region = getRegion(countryCodeCookie) ?? 'uk';

  const params = new URLSearchParams(location.search);

  params.set('region', region);

  window.history.replaceState({}, '', `${location.pathname}?${params.toString()}`);
}
